import { render } from "./template_list.vue?vue&type=template&id=1bcd37e0&scoped=true"
import script from "./templateListComponent.js?vue&type=script&lang=js"
export * from "./templateListComponent.js?vue&type=script&lang=js"

import "./template_list.vue?vue&type=style&index=0&id=1bcd37e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcd37e0"]])

export default __exports__